import { StudentFinderPage } from '@features/student-finder/components/StudentFinderPage'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'
import { requireRouteAudience } from '@services/router/routeAccess'

export const Route = createFileRoute('/_layout/students/finder')({
    component: RouteComponent,
    beforeLoad: requireRouteAudience(['staff']),
    staticData: {
        crumb: {
            label: 'Student Finder',
        }
    }
})

function RouteComponent() {
    return (
        <Suspense fallback={<LoadingIndicator resource="Student Finder" />}>
            <StudentFinderPage />
        </Suspense>
    )
}
